export default "__VITE_ASSET__LF08C04S__"